import React, { Component } from "react"
import Header from "./Header"
import Navbar from "./Navbar"
import Footer from "./Footer"

class Head extends Component {
  state = {
    navOpen: false,
  }
  handleClick = () => {
    this.setState({
      navOpen: !this.state.navOpen,
    })
  }
  render() {
    return (
      <div>
        <Header navOpen={this.state.navOpen} toggleNav={this.handleClick} />
        <Navbar navOpen={this.state.navOpen} />
        <Footer navOpen={this.state.navOpen} />
      </div>
    )
  }
}
export default Head
